import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import adminManagementReducer from './adminManagementReducer';
import adminCreateReducer from './adminCreateReducer';
import adminEditReducer from './adminEditReducer';
import logsReducer from './logsReducer';
import adminUpdatePasswordReducer from './adminUpdatePasswordReducer';
import systemInfoReducer from './systemInfoReducer';
import userManagementReducer from './userManagement';
import userCreateReducer from './userCreateReducer';
import userEditReducer from './userEditReducer';

const rootReducer = combineReducers({
    login: loginReducer,
    adminManagement: adminManagementReducer,
    adminEdit: adminEditReducer,
    adminCreate: adminCreateReducer,
    logs: logsReducer,
    adminUpdatePassword: adminUpdatePasswordReducer,
    systemInfo: systemInfoReducer,
    userManagement: userManagementReducer,
    userCreate: userCreateReducer,
    userEdit: userEditReducer,
});

export default rootReducer;
